import React from 'react';
import {Col, Row} from 'react-bootstrap';
import './css/customThemes.css';


export default function HeaderSite(){
    return (
        <div>
          <Row >
              <Col xs={3}>
                <a href="/"> 
                <img
                  className="rounded float-right d-block w-50"
                  src="https://i.imgur.com/M1GWmOv.png?text=METxico Logo&bg=373940"
                  alt="Logo de METXICO"
                />
                </a>
              </Col>
              <Col xs={{ span: 4, offset: 1 }}>
                  <h1 className="title-text" >METxico Project</h1>
                  <h2 className="title-subtext" >METabolomics of Mexico Territory</h2>
              </Col>
          </Row>
      </div>
      );
}

